export const doFilesSatisfySize = (files, size) => {
  if (size === null || size <= 0) {
    return true;
  }
  return files.every(file => {
    return file.size <= size;
  });
};